import React from 'react';
import { Link } from '@reach/router';

export default () => (
  <section className='container-fluid p-md-0'>
        <div className='row'>

          <div className='col-md-6 order-2 order-md-1 centered'>
            <img src='./img/biobag.png' alt='imgbanner' className='w-100 border-radius banner-contact-img'/>
          </div>
          <div className='col-md-6 centered order-1 order-md-2'>
            <div>
              <div className="subheading mt-md-0 mt-5">
                Witaly Group | Environment
              </div>
              <div className="heading">
                Bio Witaly
              </div>
              <p>
                Welcome to BioWitaly, where sustainability meets innovation in waste management. 
                <span className='br'></span>Smart Disposal Solutions is our commitment to creating a cleaner, greener future for our planet. 
                <span className='br'></span>Reducing waste and promoting environmental responsibility.
              </p>
              <Link className='btn' to="">
                <span className="shine"></span>
                <span>More Detail</span>
              </Link>
            </div>
          </div>
          
        </div>
    </section>
);
